// API route for contact form submission
// This is a client-side mock implementation
// In production, replace with actual backend API endpoint

export async function submitContactForm(data) {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 1000));

  // In production, integrate with:
  // - Resend (https://resend.com)
  // - SendGrid (https://sendgrid.com)
  // - Formspree (https://formspree.io)
  // - Netlify Forms (if hosting on Netlify)

  return {
    success: true,
    message: 'Form submitted successfully',
  };
}

// Example production implementation with Resend:
/*
import { Resend } from 'resend';

const resend = new Resend(process.env.VITE_RESEND_API_KEY);

export async function submitContactForm(data) {
  const { name, email, organization, serviceInterest, message } = data;

  try {
    // Send email to Dr. Ridoré
    await resend.emails.send({
      from: 'The Poetic Method <noreply@thepoeticmethod.com>',
      to: 'poeticmethod101@gmail.com',
      replyTo: email,
      subject: `New Inquiry from ${name}${organization ? ` (${organization})` : ''}`,
      html: `
        <h2>New Contact Form Submission</h2>
        <p><strong>Name:</strong> ${name}</p>
        <p><strong>Email:</strong> ${email}</p>
        ${organization ? `<p><strong>Organization:</strong> ${organization}</p>` : ''}
        ${serviceInterest ? `<p><strong>Interest Area:</strong> ${serviceInterest}</p>` : ''}
        <p><strong>Message:</strong></p>
        <p>${message.replace(/\n/g, '<br>')}</p>
      `,
    });

    // Optional: Send confirmation to the person who submitted
    await resend.emails.send({
      from: 'The Poetic Method <noreply@thepoeticmethod.com>',
      to: email,
      subject: 'We received your message',
      html: `
        <p>Hi ${name.split(' ')[0]},</p>
        <p>Thank you for reaching out to The Poetic Method™. We've received your message and will be in touch within 1-2 business days.</p>
        <p>Warm regards,<br>The Poetic Method™ Team</p>
      `,
    });

    return { success: true };
  } catch (error) {
    console.error('Contact form error:', error);
    throw new Error('Failed to send message');
  }
}
*/